import { requests } from '@/lib/axios';
import { IResponse } from '@/utils/CommonInterface';
import { filePost,validateParam,docParam,logParam } from '../interface';

export const uploadProtected = (params:filePost): Promise<IResponse> => {
  return requests.post('/validate/protected-upload', params);
}

export const validateId = (params:validateParam): Promise<IResponse> => {
  return requests.post('/validate/diva-id', params);
}

export const validateKey = (params:validateParam): Promise<IResponse> => {
  return requests.post('/validate/diva-key', params);
}

export const getDivaDoc = (params:docParam): Promise<IResponse> => {
  return requests.post('/document/get-diva-doc', params);
}

export const getDataDoc = (params:docParam): Promise<IResponse> => {
  return requests.post('/document/get-data-doc', params);
}

export const getDocInfo = (params:docParam): Promise<IResponse> => {
  return requests.post('/document/get-doc-info', params);
}

export const logUser = (params:docParam): Promise<IResponse> => {
  return requests.post('/document/log',params);
}
